var map = {
	"./CRC Values.txt": 23448,
	"./alien.txt": 16794,
	"./bomb.txt": 55773,
	"./bowling.txt": 68508,
	"./cold_face.txt": 1936,
	"./cow_face.txt": 93595,
	"./cowboy_hat_face.txt": 15175,
	"./dog_face.txt": 55740,
	"./fire.txt": 894,
	"./flying_saucer.txt": 31551,
	"./frog.txt": 9635,
	"./ghost.txt": 97874,
	"./hear_no_evil_monkey.txt": 67867,
	"./honeybee.txt": 26962,
	"./horse.txt": 41386,
	"./kangaroo.txt": 14653,
	"./oncoming_police_car.txt": 54122,
	"./owl.txt": 44517,
	"./penguin.txt": 76790,
	"./person_juggling.txt": 26009,
	"./pig_face.txt": 25661,
	"./pile_of_poo.txt": 79918,
	"./popcorn.txt": 79755,
	"./rabbit_face.txt": 36140,
	"./robot.txt": 90511,
	"./rocket.txt": 74388,
	"./roller_coaster.txt": 40825,
	"./sloth.txt": 98627,
	"./smiling_face_with_horns.txt": 53769,
	"./smiling_face_with_sunglasses.txt": 28330,
	"./snowman.txt": 6333,
	"./soccer_ball.txt": 33207,
	"./spouting_whale.txt": 70543,
	"./unicorn.txt": 34068,
	"./volcano.txt": 77219,
	"./zombie.txt": 85730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81116;